import { render, staticRenderFns } from "./AddReceivables.vue?vue&type=template&id=73197f5d&lang=html"
import script from "./AddReceivables.vue?vue&type=script&lang=js"
export * from "./AddReceivables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports